<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="tips"
      @load="getList"
    >
      <!--<div v-for="(item,index) in list" :key="index" class="data">-->
      <!--<div class="hd">-->
      <!--{{ item.adviceType }}-->
      <!--<div class="time">{{ dateFormat(item.createTime, 'YY-MM-DD hh:mm') }}</div>-->
      <!--</div>-->
      <!--<div class="bd">-->
      <!--{{ item.adviceContent }}-->
      <!--</div>-->
      <!--</div>-->
      <van-swipe-cell v-for="(item,index) in list" :key="index" :on-close="onClose" :name="item.requestId">
        <div class="content-text">
          <div class="family">
            <div class="image">
              <van-image class="image" :src="item.headUrl" />
            </div>
            <div class="userinfo">
              <span class="userName">{{ item.name }}</span>
              <span class="time"> {{ dateFormat(item.createTime, 'MM-DD') }}</span>
            </div>
            <div v-if="item.state=='REQUEST'" class="operation">
              <span class="refuse" @click="refuse(item.requestId)">{{ $t('viewBase.a38') }}</span>
              <span class="agree" @click="agree(item.requestId)">{{ $t('viewBase.a39') }}</span>
            </div>
            <div v-else class="operation">
              <span v-if="item.state=='AGREE'" class="time">{{ $t('viewBase.a40') }}</span>
              <span v-if="item.state=='REFUSE'" class="time">{{ $t('viewBase.a41') }}</span>
            </div>

          </div>

        </div>
        <!--<van-cell :border="false" title="单元格" value="内容" />-->
        <template slot="right">
          <van-button square type="danger" class="delet_sty" :text="$t('viewBase.a3')" />
        </template>
      </van-swipe-cell>
    </van-list>

  </div>
</template>

<script>
import { dateFormat } from '@/utils/tool'
import { getUserGroupRequestUserList, userGroupRequestAgree, userGroupRequestRefuse, delUserGroupRequest } from '@/api/family'
import { Dialog, Toast } from 'vant'
export default {
  data() {
    return {
      dateFormat,
      tips: '',
      loading: false,
      finished: false,
      list: [],
      listQuery: {
        page: 1,
        row: 20
      }
    }
  },
  created() {
  },
  methods: {
    onClose(clickPosition, instance) {
      var this_ = this
      switch (clickPosition) {
        case 'left':
        case 'cell':
        case 'outside':
          instance.close()
          break
        case 'right':
          Dialog.confirm({
            message: this.$t('viewBase.a42')
          }).then(() => {
            Toast.loading({
              message: this.$t('viewBase.a43'),
              forbidClick: 0
            })
            var id = instance.name
            delUserGroupRequest({ requestId: id }).then(res => {
              Toast.clear()
              if (res.data.code === 0 && res.data.data) {
                this_.list.forEach((item, index) => {
                  if (item.requestId === id) {
                    this_.list.splice(index, 1)
                  }
                })
              }
            })
            instance.close()
          })
          break
      }
    },
    refuse(id) {
      var this_ = this
      Dialog.confirm({
        message: this.$t('viewBase.a44')
      }).then(() => {
        Toast.loading({
          message: this.$t('viewBase.a43'),
          forbidClick: 0
        })
        userGroupRequestRefuse({ requestId: id }).then(res => {
          Toast.clear()
          if (res.data.code === 0 && res.data.data) {
            this_.list.forEach(item => {
              if (item.requestId === id) {
                item.state = 'REFUSE'
              }
            })
          }
        })
      })
    },
    agree(id) {
      var this_ = this
      Dialog.confirm({
        message: this.$t('viewBase.a45')
      }).then(() => {
        Toast.loading({
          message: this.$t('viewBase.a43'),
          forbidClick: 0
        })
        userGroupRequestAgree({ requestId: id }).then(res => {
          Toast.clear()
          if (res.data.code === 0 && res.data.data) {
            this_.list.forEach(item => {
              if (item.requestId === id) {
                item.state = 'AGREE'
              }
            })
          }
        })
      })
    },
    getList() {
      getUserGroupRequestUserList(this.listQuery).then(res => {
        this.loading = false
        var list = []
        // const list = res.data.data
        if (res.data.data === null) {
          list = []
        } else {
          list = res.data.data
        }
        if (this.listQuery.page === 1) {
          this.list = list
        } else {
          this.list = this.list.concat(list)
        }
        this.listQuery.page++
        this.finished = list.length < 20
        this.tips = this.list.length ? this.$t('viewBase.a46') : this.$t('viewBase.a47')
      })
    }

  }
}
</script>

<style scoped lang="scss">
  .data {
      background: #fff;
      margin-top: 10px;
      padding: 12px 15px;
  }
  .hd {
      display: flex;
      justify-content: space-between;
      .time {
          color: #999;
          font-size: 12px;
      }
  }
  .bd {
      color: #666;
      margin-top: 5px;
  }
  .family{
    height: 60px;
    width: 100%;
    border-bottom: 1px solid #E0E0E0;;
  }
  .userinfo{
    display:inline;
    height: 60px;
    line-height: 60px
  }
  .content-text{
    padding-left: 10px;
    background-color: #fff;
  }
  .delet_sty{
    height: 100%;
  }
  .userName{
    width: 80px;
    display: inline-block;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .time{
    color: #7D7D7D;
    margin-left: 10px;
    display: inline-block;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
.operation{
  margin-right: 10px;
  float: right;
  height: 60px;
  line-height: 60px
}
  .refuse{
    margin-right: 10px;
    padding: 5px 10px;
    border: 1px solid #F18937;
    color: #F18937;
    border-radius: 4px;
  }
  .agree{
    padding: 5px 10px;
    border: 1px solid #F18937;
    color: #fff;
    background-color: #F18937;
    border-radius: 4px;
  }
  .image{
    float: left;
    margin-right: 10px;
    margin-top: 5px;
    .van-image{
      vertical-align: middle;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
    }
  }
</style>
